import { c as _c } from "react/compiler-runtime";
import { FC } from 'react';
interface Props {
  size?: string | number;
  className?: string;
}
const Check: FC<Props> = t0 => {
  const $ = _c(4);
  const {
    size: t1,
    className
  } = t0;
  const size = t1 === undefined ? 16 : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M5.40681 11.0946L2.29719 7.98497L1.23828 9.03643L5.40681 13.205L14.3554 4.25641L13.3039 3.20496L5.40681 11.0946Z" fill="currentColor" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== className || $[2] !== size) {
    t3 = <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16" fill="none" className={className}>{t2}</svg>;
    $[1] = className;
    $[2] = size;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
export default Check;